import GlobalStyle from '../../../utils/sass/global.module.scss'
import { ChatBox, Files, Messages } from '../../../components/chat';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { getAdminSupport } from '../../../store/chat/chatActions';

const chatCol =
    'h-[800px] max-md:max-h-screen shrink-0 bg-white p-5 rounded-[20px]';
const messagesCol = `${chatCol} w-[350px] max-md:max-w-[calc(100%-40px)]`;
const chatMainCol = `${chatCol} flex flex-1 min-w-0 w-full items-center justify-center lg:w-[calc(100%-350px)]`;
const filesCol = `${chatCol} w-[350px]`;

const SupportPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [defaultChat, setDefalultChat] = useState(null);
    const dispatch = useDispatch();
    const { id } = useParams()
    
    useEffect(() => {
        setIsLoading(true)
        console.log(id)
        if(id) {
            setDefalultChat(id)
        }
        dispatch(getAdminSupport())
            .unwrap()
            .then((v) => {
                setIsLoading(false)
            })
    }, []);

    return (
        <div>
            <h1 className={GlobalStyle.pageTitle}>Chat</h1>

            <div className="flex gap-5">
                <div className={messagesCol}>
                    <Messages defaultChat={defaultChat}/>
                </div>
                <div className={chatMainCol}>
                    <ChatBox  />
                </div>
                <div className={filesCol}>
                    <Files />
                </div>
            </div>
        </div>
    )
}

export default SupportPage;
